export const DEMO_STEP_IDS = [
  'welcome',
  'dashboard',
  'alerts',
  'candidates',
  'import-candidates',
  'connect-ats',
  'ai-assistant',
  'test-scrape',
  'candidate-profile',
  'test-call',
];

export const DEMO_STEPS = DEMO_STEP_IDS.map((id) => ({
  id,
  titleKey: `demo.steps.${id}.title`,
  bodyKey: `demo.steps.${id}.body`,
}));

export const DEMO_TEST_CALL_SKIPPED_FLAG = 'test-call-skipped';
export const DEMO_COMPLETE_VIEW_ID = 'complete';

export const normalizeDemoStepsCompleted = (value) => {
  if (Array.isArray(value)) {
    return value.map((step) => String(step)).filter(Boolean);
  }
  return [];
};

export const getCompletedDemoStepIds = (value) => (
  normalizeDemoStepsCompleted(value).filter((stepId) => DEMO_STEP_IDS.includes(stepId))
);

export const isDemoIncomplete = (profile) => (
  Boolean(profile) && !profile.demo_completed_at
);

export const getCurrentDemoStepIndex = (profile) => {
  const completed = new Set(getCompletedDemoStepIds(profile?.demo_steps_completed));
  const index = DEMO_STEP_IDS.findIndex((id) => !completed.has(id));
  return index === -1 ? DEMO_STEP_IDS.length - 1 : index;
};

export const getDemoStepIndexById = (stepId) => {
  const index = DEMO_STEP_IDS.indexOf(String(stepId || ''));
  return index >= 0 ? index : 0;
};

export const isDemoStepId = (stepId) => DEMO_STEP_IDS.includes(String(stepId || ''));

export const isDemoCompleteView = (stepId) => String(stepId || '') === DEMO_COMPLETE_VIEW_ID;

export const hasSkippedDemoTestCall = (completedSteps) => (
  normalizeDemoStepsCompleted(completedSteps).includes(DEMO_TEST_CALL_SKIPPED_FLAG)
);

export const isDemoStepUpcoming = (stepId, currentStepId) => {
  if (!isDemoStepId(stepId) || !isDemoStepId(currentStepId)) return false;
  return getDemoStepIndexById(stepId) > getDemoStepIndexById(currentStepId);
};

export const isDemoStepCompleted = (stepId, completedSteps) => {
  if (!isDemoStepId(stepId)) return false;
  if (stepId === 'test-call' && hasSkippedDemoTestCall(completedSteps)) return false;
  return getCompletedDemoStepIds(completedSteps).includes(String(stepId));
};
